import { render, staticRenderFns } from "./higher-way-fan.vue?vue&type=template&id=463a68f9&"
import script from "./higher-way-fan.js?vue&type=script&lang=js&"
export * from "./higher-way-fan.js?vue&type=script&lang=js&"
import style0 from "./higher-way-fan.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports